import { Component } from '@angular/core';
import { AuthService } from '../auth.service';
import { Router } from '@angular/router';

@Component({
    selector: 'update-password',
    templateUrl: './update-password.component.html',
    styleUrls: ['./update-password.component.css'],
    standalone: false
})
export class UpdatePasswordComponent {

    passwordUpdated: boolean = false;
    toggle: boolean = false;
    toggle2: boolean = false;
    toggle3: boolean = false;
  
  
    password: string;
    newPassword: string;
    confirmPassword: string;
  
    constructor(private authService: AuthService, private router: Router){
      this.init();
    }

    init(){
      this.password = '';
      this.newPassword = '';
      this.confirmPassword = '';
    }

    homeScreen(){
      this.router.navigate(['/']);
    }

    async updatePassword(){
      if(this.password === '' || this.newPassword === '' || this.confirmPassword ===''){
        this.authService.openSnackBar('Check you inputs', '');
        return;
      }

      if(this.newPassword !== this.confirmPassword){
        this.authService.openSnackBar('Passwords do not match!','PLase make sure new passwords match!');
        return;
      }

      let result = await this.authService.updatePassword(this.password, this.newPassword);
      if(result){
        this.passwordUpdated = true;
        this.authService.openSnackBar('Password reset', '');
        setTimeout(() =>{
          this.passwordUpdated = false;
        }, 5000);

        this.authService.logout();
        
        this.router.navigate(['/login']);
        return;
      }

      this.authService.openSnackBar('There was an issue updating password', 'Please try again');



    }
  
  
    toggleView(){
      if(this.toggle){
        this.toggle = false;
      }else{
        this.toggle = true;
      }
    }
  
    toggleView2(){
      if(this.toggle2){
        this.toggle2 = false;
      }else{
        this.toggle2 = true;
      }
    }

    toggleView3(){
      if(this.toggle3){
        this.toggle3 = false;
      }else{
        this.toggle3 = true;
      }
    }

}
